import { CustomInputMappingField } from "../../../redux";
import { JsonDataType } from "../JsonDataType";

const DEFAULT_JSON_CALC = { params: [], template: "", operations: [], calculationUnits: '' }
const defaultJSON = `${DEFAULT_JSON_CALC}`

type CalculateField = ['' | 'error' | string, string]

export const  isNumeric = (val: any) => {
    var _val = +val;
    return (val !== val + 1)
        && (_val === +val)
        && (typeof val !== 'object')
}

export const getStringAsNum = (val: string) => {
    let defa = val ? parseInt(val, 10) : 0
    let x = defa
    try {
        const y = val ? eval(val) : 0
        x = isNumeric(y) ? y : defa
    } catch (e) {
        x = defa
    }
    return x
}

export const calculateField = (field: CustomInputMappingField, data: JsonDataType): CalculateField => {
    const options = field.options ?? defaultJSON
    
    try {
        const x = JSON.parse(options)
        const {template, params, calculationUnits = ''} = x

        const isAnyNot = params.some((x: string) => {
            const val = data[x]
            return val === '' || val === null || val === undefined
        })

        const isAnySingleMinus = params.some((x: string) => {
            const val = data[x]
            return val === '-'
        })

        if(!!isAnyNot) return ['', '']
        if(!!isAnySingleMinus) return ['error', '']

        let lastPos = 0
        let poss: {[key in string]: string} = {
    
        }
        const expression = params.reduce((accum: string, current: string) => {
            if(!(current in poss)) {
                poss[current] = lastPos + ''
                lastPos++
            }
            const value = (data[current] ?? '0') as string
            const pos = poss[current]
            accum = accum.replace(`{${pos}}`, value)
            
            return accum
        }, template)
        
        const res = eval(expression)
        if(!isNumeric(res)) return ['error', '']
        return [res + '', calculationUnits]
    } catch (err) {        
        return ['error', '']
    }
}
export const getUnitsOfcalculateField = (field: CustomInputMappingField): string => {
    const options = field.options ?? defaultJSON
    
    try {
        const x = JSON.parse(options)
        const {calculationUnits = ''} = x

        return calculationUnits
    } catch (err) {        
        return ''
    }
}

export const isCalculatedFieldDependOnField = (field: CustomInputMappingField, sourceField: string): boolean => {
    const options = field.options ?? defaultJSON
    
    try {
        const x = JSON.parse(options)
        const {params = [] } = x

        return params.includes(sourceField)
    } catch (err) {        
        return false
    }
}

export const isValidCalculated = (calcV: string) => {
    if(!!calcV && calcV !== 'error') return true
    return false
}

export const getCalculatedWithUnits = (calcV: string, units: string) => {
    return !!calcV && calcV !== 'error' ? (units === '$' ? units + calcV : calcV + units) : ''
}